if (!customElements.get('toggle-cross-sell')) {
    customElements.define(
        'toggle-cross-sell',

        class ToggleCrossSell extends HTMLElement {
            constructor() {
                super();
                this.main_product_form = document.querySelector(
                    '.product-form form[action="/cart/add"], .product__page form[action="/cart/add"], .product form[action="/cart/add"], form[action="/cart/add.js"], form[action="/cart/add"]'
                );
                this.initPrice = 0;
                this.initComparePrice = 0;
                if (!this.main_product_form) {
                    console.error('ToggleCrossSell: No product form found');
                    return;
                }
            }

            connectedCallback() {
                this.addEventListener('click', this.onToggleProduct.bind(this));
                this.querySelectorAll('.toggle-cross-sell__product').forEach((product) => {
                    const select = product.querySelector('.deployer-select');
                    if (select) {
                        select.addEventListener('change', this.variantChanged.bind(this, product));
                    }

                    const colorSwatches = product.querySelectorAll('.toggle-cross-sell__colorswatch');
                    if (colorSwatches.length) {
                        colorSwatches.forEach((swatch) =>
                            swatch.addEventListener('click', this.onColorSwatchClick.bind(this, product, swatch))
                        );
                    }
                });
                this.getPrices();
            }

            disconnectedCallback() {
                this.removeEventListener('click', this.onToggleProduct.bind(this));
                this.querySelectorAll('.toggle-cross-sell__product').forEach((product) => {
                    const select = product.querySelector('.deployer-select');
                    if (select) {
                        select.removeEventListener('change', this.variantChanged.bind(this, product));
                    }

                    const colorSwatches = product.querySelectorAll('.toggle-cross-sell__colorswatch');
                    colorSwatches.forEach((swatch) =>
                        swatch.removeEventListener('click', this.onColorSwatchClick.bind(this, product, swatch))
                    );
                });
            }

            onToggleProduct(event) {
                let checkbox;

                if (event.target.type === 'checkbox') {
                    checkbox = event.target;
                    this.updateMainFormInputs();
                    this.updateMainCtaPrice();
                    event.stopPropagation();
                } else {
                    checkbox = event.target.querySelector('input[type="checkbox"]');
                    if (checkbox) {
                        checkbox.checked = !checkbox.checked;
                        this.updateMainFormInputs();
                        this.updateMainCtaPrice();
                    }
                }
            }

            onColorSwatchClick(product, swatch) {
                this.clearActiveColorSwatches(product);
                swatch.classList.add('active');
                this.variantChanged(product, swatch);
            }

            clearActiveColorSwatches(product) {
                product.querySelectorAll('.toggle-cross-sell__colorswatch.active').forEach((swatch) => {
                    swatch.classList.remove('active');
                });
            }

            variantChanged(product, element) {
                let optionSelected;
                let value;

                if (element.tagName === 'SELECT') {
                    optionSelected = element.options[element.selectedIndex];
                    value = optionSelected.value;
                } else {
                    optionSelected = element;
                    value = element.dataset.value;
                    this.updateVariantDetails(product, element.dataset.details);
                }

                this.updateProductPrice(product, optionSelected);
                this.updateProductImage(product, optionSelected);
                this.updateVariantId(product, value);
            }

            getPrices() {
                const currentVariantId = this.main_product_form.querySelector("input[name='id']").value;
                const priceElement = document.querySelector(`#cta-product-price-${currentVariantId}`);
                if (priceElement) {
                    const compareAtPriceElement = priceElement.querySelector("#cta-product-compare-price");
                    if (compareAtPriceElement) this.initComparePrice = parseFloat(compareAtPriceElement.textContent);
                    this.initPrice = parseFloat(priceElement.textContent);
                }
            }

            updateProductPrice(product, optionSelected) {
                const price = optionSelected.dataset.price || '';
                const compareAtPrice = optionSelected.dataset.compareAtPrice || '';
                const discount = optionSelected.dataset.discountPercentage || '';

                product.querySelector('.toggle-cross-sell__product-price').innerHTML = price;

                const compareAtPriceEl = product.querySelector('.toggle-cross-sell__product-compare-at-price');
                const badgeEl = product.querySelector('.toggle-cross-sell__product-badge-discount');

                if (compareAtPriceEl && badgeEl) {
                    if (compareAtPrice) {
                        compareAtPriceEl.innerHTML = compareAtPrice;
                        badgeEl.innerHTML = discount;
                        compareAtPriceEl.style.display = 'block';
                        badgeEl.style.display = 'flex';
                    } else {
                        compareAtPriceEl.style.display = 'none';
                        badgeEl.style.display = 'none';
                    }
                }
            }

            updateProductImage(product, optionSelected) {
                const variantImage = optionSelected.dataset.variantImage;
                const imageEl = product.querySelector('.toggle-cross-sell__product-image img');

                if (variantImage && imageEl) {
                    imageEl.src = variantImage;
                }
            }

            updateVariantId(product, id) {
                const input = product.querySelector('.deployer-checkbox input');
                if (input) {
                    input.dataset.variantId = id;
                    input.checked = true;
                    this.updateMainFormInputs();
                }
            }

            resetMainFormInputs() {
                document.querySelectorAll('.from-toggle-cross-sell').forEach((input) => input.remove());
            }

            updateMainFormInputs() {
                this.resetMainFormInputs();

                this.querySelectorAll('.toggle-cross-sell__product').forEach((product) => {
                    const checkbox = product.querySelector('input[type="checkbox"]');
                    if (checkbox && checkbox.checked) {
                        const variantId = checkbox.dataset.variantId;
                        this.main_product_form.insertAdjacentHTML(
                            'beforeend',
                            `<input type="hidden" class="from-toggle-cross-sell" name="id" value="${variantId}">`
                        );
                    }
                });
            }

            updateVariantDetails(product, details) {
                const detailsEl = product.querySelector('.toggle-cross-sell__details');
                if (detailsEl) {
                    detailsEl.innerHTML = details;
                }
            }

            updateMainCtaPrice() {
                const currentVariantId = this.main_product_form.querySelector("input[name='id']").value;
                const priceElements = document.querySelectorAll(`#cta-product-price-${currentVariantId}`);
                let price = this.initPrice;
                let compareAtPrice = this.initComparePrice;

                this.querySelectorAll('.toggle-cross-sell__product').forEach((product) => {
                    const checkbox = product.querySelector("input[type='checkbox']");
                    if (checkbox && checkbox.checked) {
                        price += parseFloat(product.querySelector('.toggle-cross-sell__product-price').textContent);
                        const compareAtPriceEl = product.querySelector('.toggle-cross-sell__product-compare-at-price');
                        if (compareAtPriceEl) compareAtPrice += parseFloat(compareAtPriceEl.textContent);
                        else compareAtPrice += parseFloat(product.querySelector('.toggle-cross-sell__product-price').textContent);
                    }
                });

                priceElements.forEach((priceElement) => {
                    const compareAtPriceElement = priceElement.querySelector("#cta-product-compare-price");
                    if (compareAtPriceElement) {
                        compareAtPriceElement.textContent = `${compareAtPrice}€`;
                        priceElement.textContent = `${price}€`;
                        priceElement.appendChild(compareAtPriceElement);
                    }
                    else
                        priceElement.textContent = `${price}€`;
                });
            }
        }
    );
}
